"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var moment = require('moment');

// entitlement types
var TYPE_ACCOUNT = 'ACCOUNT';
var TYPE_EVENT = 'EVENT';
var TYPE_TRANSACTION = 'TRANSACTION';
var TYPE_EXPIRED = 'EXPIRED';
var TYPE_EXPIRED_EVENT = 'EXPIRED_EVENT';
var TYPE_SETTLEMENT = 'SETTLEMENT';

// helper function for $http calls
var unwrapReponse = function unwrapReponse() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    data = _ref.data;
  return data;
};
var EntitlementsService = /*#__PURE__*/function () {
  EntitlementsService.$inject = ["$q", "$http", "$filter", "$sce", "eventService", "ENTITLEMENTS_SERVICE_ENDPOINT", "ENTITLEMENT_PRODUCT_CODES_SERVICE_ENDPOINT"];
  /* @ngInject */
  function EntitlementsService($q, $http, $filter, $sce, eventService, ENTITLEMENTS_SERVICE_ENDPOINT, ENTITLEMENT_PRODUCT_CODES_SERVICE_ENDPOINT) {
    _classCallCheck(this, EntitlementsService);
    this.$q = $q;
    this.$http = $http;
    this.$sce = $sce;
    this.eventService = eventService;
    this.capitalize = $filter('capitalize');
    this.entitlementsEndpoint = ENTITLEMENTS_SERVICE_ENDPOINT;
    this.productCodesEndpoint = ENTITLEMENT_PRODUCT_CODES_SERVICE_ENDPOINT;

    // expose types
    this.TYPE_ACCOUNT = TYPE_ACCOUNT;
    this.TYPE_EVENT = TYPE_EVENT;
    this.TYPE_TRANSACTION = TYPE_TRANSACTION;
    this.TYPE_EXPIRED = TYPE_EXPIRED;
    this.TYPE_EXPIRED_EVENT = TYPE_EXPIRED_EVENT;
    this.TYPE_SETTLEMENT = TYPE_SETTLEMENT;
  }

  /**
   * Returns the purchased products by a specific organization
   *
   * @param {string} organisationID - The _id of the organisation
   * @param {string} [productType] - Product type to filter by
   * @returns {promise} - A promise that resolves with the purchased products
   */
  return _createClass(EntitlementsService, [{
    key: "getPurchaseOrganizationProducts",
    value: function getPurchaseOrganizationProducts(organisationID) {
      var productType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var endpointUrl = "".concat(this.entitlementsEndpoint, "/").concat(organisationID, "/reduced-bought");
      if (productType) {
        endpointUrl += "/".concat(productType);
      }
      return this.$http.get(endpointUrl, {
        withCredentials: true
      }).then(unwrapReponse);
    }

    /**
     * Returns paginated product transactions for a specific organization
     *
     * @param {string} organisationID - The _id of the organisation
     * @param {String[]} productCodes - Codes of the product for which to get transactions
     * @param {String[]} entitlementTypes - entitlement types to return
     * @param {String} eventId - the ID of the event
     * @param {object} pagination - The the object specifying the pagination
     * @returns {promise} - A promise that resolves with the product transactions
     */
  }, {
    key: "getOrganizationProductTransactions",
    value: function getOrganizationProductTransactions(organisationID, productCodes, entitlementTypes, eventId, pagination) {
      var _this = this;
      return this.$http.get("".concat(this.entitlementsEndpoint, "/").concat(organisationID, "/all-paginated"), {
        params: _.extend({
          eventId: eventId,
          productCodes: JSON.stringify(productCodes),
          entitlementTypes: JSON.stringify(entitlementTypes)
        }, pagination),
        withCredentials: true
      }).then(function (response) {
        return {
          hasNextPage: response.data.hasNextPage,
          hasPreviousPage: response.data.hasPreviousPage,
          items: _this._formatTransactionsData(response.data.items, !!eventId)
        };
      });
    }

    /**
     * Returns paginated transactions for a specific organization
     *
     * @param {string} organisationID - The _id of the organisation
     * @param {object} pagination - The the object specifying the pagination
     * @returns {promise} - A promise that resolves with the organization transactions
     */
  }, {
    key: "getOrganizationTransactions",
    value: function getOrganizationTransactions(organisationID, productCodes, pagination) {
      var _this2 = this;
      return this.$http.get("".concat(this.entitlementsEndpoint, "/").concat(organisationID, "/all-paginated"), {
        params: _.extend({
          entitlementTypes: JSON.stringify(productCodes)
        }, pagination),
        withCredentials: true
      }).then(function (response) {
        return {
          hasNextPage: response.data.hasNextPage,
          hasPreviousPage: response.data.hasPreviousPage,
          items: _this2._formatTransactionsData(response.data.items)
        };
      });
    }

    /**
     * Returns available product pools for a list of product codes
     *
     * @param {string} organisationID - The _id of the organisation
     * @param {Array} productCodes - list of product to retrieve
     * @returns {promise} - A promise that resolves with the organization transactions
     */
  }, {
    key: "getOrganizationProductPools",
    value: function getOrganizationProductPools(organisationID, productCodes) {
      return this.$http.get("".concat(this.entitlementsEndpoint, "/").concat(organisationID, "/available-product-pools"), {
        params: {
          productCodes: JSON.stringify(productCodes || [])
        },
        withCredentials: true
      }).then(unwrapReponse);
    }

    /**
     * Returns paginated event entitlements for a specific organization
     *
     * @param {string} organisationID - The _id of the organisation
     * @param {object} pagination - The object specifying the pagination
     * @returns {promise} - A promise that resolves with the organization's event entitlements
     */
  }, {
    key: "getOrganizationEventsWithEntitlements",
    value: function getOrganizationEventsWithEntitlements(organisationID, pagination) {
      return this.$http.get("".concat(this.entitlementsEndpoint, "/").concat(organisationID, "/events-paginated"), {
        params: pagination,
        withCredentials: true
      }).then(unwrapReponse);
    }

    /**
     * Returns products for specific event for a specific organization
     *
     * @param {string} organisationId - The _id of the organisation
     * @param {object} eventId - The _id of the event
     * @returns {promise} - A promise that resolves with the organization's event entitlements
     */
  }, {
    key: "getOrganizationEventEntitlements",
    value: function getOrganizationEventEntitlements(organisationId, eventId) {
      return this.$http.get("".concat(this.entitlementsEndpoint, "/").concat(organisationId, "/events/").concat(eventId), {
        withCredentials: true
      }).then(unwrapReponse);
    }

    /**
     * Returns usage report for subscription and packages for a given event
     *
     * @param {string} eventId - The _id of the event
     * @returns {promise} - A promise that resolves with the event's usage report
     */
  }, {
    key: "getEventUsageReport",
    value: function getEventUsageReport(eventId) {
      return this.$http.get("".concat(this.entitlementsEndpoint, "/usage-report/").concat(eventId), {
        withCredentials: true
      }).then(unwrapReponse);
    }

    /**
     * Make a transaction for entitlements
     *
     * @param {Object} organisationID - transaction configuration
     * @returns {promise} - A promise that resolves if the transaction was successful
     */
  }, {
    key: "createEntitlementTransaction",
    value: function createEntitlementTransaction(_ref2) {
      var parentEntitlementId = _ref2.parentEntitlementId,
        quantity = _ref2.quantity,
        organisationID = _ref2.organisationID,
        eventId = _ref2.eventId;
      return this.$http.post("".concat(this.entitlementsEndpoint, "/").concat(organisationID, "/transaction"), {
        parentEntitlementId: parentEntitlementId,
        quantity: quantity,
        eventId: eventId
      }, {
        withCredentials: true
      });
    }

    /**
     * Fetches all products for an event with usage data and returns only the ones that are available
     *
     * @param {string} organisationId - The id of the organisation for which to fetch data
     * @returns {promise} - A promise that resolves with the organisation data
     */
  }, {
    key: "getAvailableProducts",
    value: function getAvailableProducts(organisationId) {
      return this.getPurchaseOrganizationProducts(organisationId).then(function (products) {
        return products.filter(function (product) {
          return product.usage && product.usage.available && product.usage.available > 0;
        });
      });
    }

    /**
     * Formats entitlements data
     *
     * @param {object} entitlements
     * @returns {object}
     */
  }, {
    key: "_formatTransactionsData",
    value: function _formatTransactionsData(entitlements) {
      var _this3 = this;
      var formatForEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return entitlements.map(function (entitlement) {
        var details = '';
        var debit = 0;
        var credit = 0;
        var type = entitlement.type,
          product = entitlement.product,
          id = entitlement.id,
          eventId = entitlement.eventId,
          eventNodeUrl = entitlement.eventNodeUrl,
          eventName = entitlement.eventName,
          expiredMs = entitlement.expiredMs,
          eventValidFromMs = entitlement.eventValidFromMs,
          validFromMs = entitlement.validFromMs,
          purchaseDateMs = entitlement.purchaseDateMs;
        var date = expiredMs || eventValidFromMs || validFromMs || purchaseDateMs;
        var eventNode = (eventNodeUrl || '').split('.')[0].replace('https://', '').replace('http://', '');
        var backstageUrl = _this3.eventService.generateGeoOptimalEventUrl({
          node: eventNode,
          id: eventId || ''
        }, '', window.location.protocol);
        if (type === TYPE_ACCOUNT) {
          details = "".concat(_this3.capitalize(product.name), " pool received");
          credit = product.quantity;
        } else if (type === TYPE_EXPIRED) {
          details = "".concat(_this3.capitalize(product.name), " pool expired");
          debit = product.quantity;
        } else if (type === TYPE_EXPIRED_EVENT) {
          details = "".concat(_this3.capitalize(product.name), " expired");
          debit = product.quantity;
        } else if (type === TYPE_TRANSACTION || type === TYPE_SETTLEMENT) {
          var action = type === TYPE_SETTLEMENT ? 'settled' : 'transferred';
          var eventLink = eventNode.length > 0 && eventName ? _this3.$sce.trustAsHtml(" <a href=\"".concat(backstageUrl, "\" target=\"_blank\">").concat(eventName, "</a>")) : eventId || '';
          details = "".concat(_this3.capitalize(product.name), " ").concat(action, " ").concat(eventLink);
          if (formatForEvent) {
            credit = product.quantity;
          } else {
            debit = product.quantity;
          }
        } else if (type === TYPE_EVENT) {
          details = "".concat(_this3.capitalize(product.name), " received");
          credit = product.quantity;
        }
        return {
          _id: id,
          _entitlement: entitlement,
          // displayed fields
          date: moment(date).format('YYYY/MM/DD'),
          details: details,
          debit: debit,
          credit: credit,
          available: formatForEvent ? product.eventAvailability : product.accountAvailability
        };
      });
    }

    /**
     * Get all details about an entitlement (parent, child, ...)
     * @param {String} organisationId
     * @param {String} entitlementId
     * @return {Promise}
     */
  }, {
    key: "getEntitlement",
    value: function getEntitlement(organisationId, entitlementId) {
      return this.$http.get("".concat(this.entitlementsEndpoint, "/").concat(organisationId, "/entitlement/").concat(entitlementId), {
        withCredentials: true
      }).then(unwrapReponse);
    }

    /**
     * Get overage report for the organization
     *
     * @param {string} organisationId
     */
  }, {
    key: "getOrganizationOverageReport",
    value: function getOrganizationOverageReport(organisationId) {
      return this.$http.get("".concat(this.entitlementsEndpoint, "/").concat(organisationId, "/overage-report"), {
        withCredentials: true
      }).then(unwrapReponse);
    }

    /**
     * Creates excel export job for entitlements given a type and organizationId
     *
     * @param {string} organisationId
     * @param {string} type
     * @returns {promise} - A promise that resolves with object containing the jobId
     */
  }, {
    key: "createEventEntitlementsExportJob",
    value: function createEventEntitlementsExportJob(type, organisationId) {
      return this.$http.get("".concat(this.entitlementsEndpoint, "/").concat(organisationId, "/").concat(type, ".xlsx"), {
        withCredentials: true
      }).then(unwrapReponse);
    }

    /**
     * Returns status for job given it's id
     *
     * @param {string} jobId
     * @returns {promise} - A promise that resolves with object containing job's status
     */
  }, {
    key: "getJobStatus",
    value: function getJobStatus(jobId) {
      return this.$http.get("/api/v1/task-queue/job/".concat(jobId, "/status")).then(unwrapReponse);
    }

    /**
     * Returns paginated product mappings
     *
     * @param {object} pagination - The the object specifying the pagination
     * @returns {promise} - A promise that resolves with the product mappings
     */
  }, {
    key: "getProductMappings",
    value: function getProductMappings(pagination) {
      return this.$http.get("".concat(this.productCodesEndpoint), {
        params: pagination,
        withCredentials: true
      }).then(unwrapReponse);
    }

    /**
     * Saves a product mapping
     *
     * @param {object} mapping - The mapping document
     * @returns {promise} - A promise that resolves when the mapping is saved
     */
  }, {
    key: "addProductMapping",
    value: function addProductMapping(mapping) {
      return this.$http.post("".concat(this.productCodesEndpoint), mapping, {
        withCredentials: true
      }).then(unwrapReponse);
    }

    /**
     * Remove a product mapping
     *
     * @param {String} erpProductCode - The mapping product code
     * @returns {promise} - A promise that resolves when the mapping is removed
     */
  }, {
    key: "removeProductMapping",
    value: function removeProductMapping(erpProductCode) {
      return this.$http.delete("".concat(this.productCodesEndpoint, "/").concat(erpProductCode), {
        withCredentials: true
      });
    }

    /**
     * Edit a product mapping
     *
     * @param {object} mapping - The mapping document
     * @returns {promise} - A promise that resolves when the mapping is saved
     */
  }, {
    key: "editProductMapping",
    value: function editProductMapping(mapping) {
      return this.$http.put("".concat(this.productCodesEndpoint, "/").concat(mapping.erpProductCode), mapping, {
        withCredentials: true
      }).then(unwrapReponse);
    }

    /**
     * Clean entitlements cache
     *
     * @returns {promise} - A promise that resolves when the mapping is saved
     */
  }, {
    key: "flushCache",
    value: function flushCache() {
      return this.$http.get("".concat(this.entitlementsEndpoint, "/_flush_cache"), {
        withCredentials: true
      }).then(unwrapReponse);
    }

    /**
     * Creates settlement transaction for given event
     *
     * @param {String} orgId organization ID
     * @param {String} eventId event ID
     * @param {Object} product product object
     * @param {String} comment transaction comment
     * @param {Number} seatCount number of seats to transfer
     * @returns {Promise}
     */
  }, {
    key: "settleOverUsage",
    value: function settleOverUsage(orgId, eventId, product, comment, seatCount) {
      var postData = {
        event_id: eventId,
        product_type: product.type,
        comment: comment,
        product_name: product.name,
        quantity: seatCount
      };
      return this.$http.post("".concat(this.entitlementsEndpoint, "/").concat(orgId, "/settle-over-usage"), postData);
    }
  }]);
}();
angular.module('backstage.services').service('entitlementsService', EntitlementsService);